import React, { useState } from 'react';
import {
  //Flex,
  Box,
  Badge,
  Text,
  useColorModeValue,
  VStack,
  HStack,
  Image,
  Spinner,
  Skeleton,
} from '@chakra-ui/react';
//import timeAgo from '../../utils/timeAgo';
import dateUtils from '../../utils/formatDate';
import { useTranslation } from 'react-i18next';

const RedeemedHistory = ({ redeemedRewards, isLoading, children, selectedYear, selectedMonth }) => {
  const bgColor = useColorModeValue('custom.900', 'gray.700');
  const textbgColor = useColorModeValue('custom.800', 'gray.200');
  const badgeTextColor = useColorModeValue('red.500', 'red.300');
  const [imageLoaded, setImageLoaded] = useState(false);
  const savedLanguage = localStorage.getItem("i18nextLng") || "en";
  const {t} = useTranslation();

  const handleImageLoad = () => {
    setImageLoaded(true); // Set the image loaded state to true once the image is fetched
  };

  return (
    <VStack align="stretch" w="full" spacing={4} overflowY="auto" maxHeight="400px">
      <Box color={textbgColor}>{children}</Box>

      {isLoading ? (
        // Skeleton Loaders
        Array.from({ length: 5 }).map((_, index) => (
          <Box key={index} p={4} borderBottomWidth={2} bg={bgColor} borderRadius="xl" width="full">
            <HStack spacing={2} align="flex-start" justify="space-between" width="100%">
              {/* Skeleton for Image */}
              <Skeleton height="60px" width="80px" borderRadius="lg" />
              
              {/* Skeleton for Reward Details */}
              <Box flex="1" minWidth="0">
                <Skeleton height="16px" width="80%" mb={2} />
                <Skeleton height="12px" width="60%" />
              </Box>

              {/* Skeleton for Points */}
              <VStack align="flex-end" spacing={2} mt={-2}>
                <Skeleton height="20px" width="50px" />
                <Skeleton height="14px" width="80px" />
              </VStack>
            </HStack>
          </Box>
        ))
      ) : redeemedRewards.length === 0 ? (
        <Text fontSize={'sm'} textAlign='center' color="gray.500">
          {t('no_data_with_date', { 
            date: dateUtils.formatDateDisplay(selectedYear, selectedMonth, savedLanguage)
          })}
        </Text>
      ) : (
        redeemedRewards.map((entry) => (
          <Box
            key={`${entry.reward._id}-${entry.redeemed_date}`}
            p={4}
            borderBottomWidth={2}
            bg={bgColor}
            borderRadius="xl"
            width="full"
          >
            <HStack spacing={2} align="flex-start" justify="space-between" width="100%">
              {/* Reward Image */}
              <Box position="relative" width="100px" height="60px">
                {!imageLoaded && (
                  <Box
                    position="absolute"
                    top="50%"
                    left="50%"
                    transform="translate(-50%, -50%)"
                    zIndex={1}
                  >
                    <Spinner size="lg" color="teal" />
                  </Box>
                )}

                <Image
                  src={entry.reward.image_url ? entry.reward.image_url : '/default_reward.jpg'}
                  width="80px"
                  height="60px"
                  alt={entry.reward.title}
                  borderRadius="lg"
                  objectFit="cover"
                  flexShrink={0}
                  alignSelf="flex-start"
                  onLoad={handleImageLoad}
                  opacity={imageLoaded ? 1 : 0}
                  position="absolute"
                  top={0}
                  left={0}
                />
              </Box>

              {/* Reward Details */}
              <Box flex="1" minWidth="0" textAlign="left" color={textbgColor}>
                <Text fontWeight="bold" fontSize="xs" mb={1} noOfLines={2}>
                  {entry.reward.title}
                </Text>
                <Text fontSize="xs" color="gray.500">
                  {dateUtils.formatDate(entry?.redeemed_date, savedLanguage)}
                </Text>
              </Box>

              {/* Used Points */}
              <VStack align="flex-end" spacing={2} mt={-1}>
                <HStack spacing={2} justify="flex-end" align="center">
                  <Text color={badgeTextColor} fontSize="xl" fontWeight="bold">
                    -{dateUtils.convertToBurmeseNumerals(entry.reward.points_required, savedLanguage)}
                  </Text>
                  <Badge colorScheme="red" px={2} py={1} borderRadius="md">
                    {t('point')}
                  </Badge>
                </HStack>

                {/* Redeemed Date */}
                <HStack spacing={2}>
                  <Text fontSize="xs" color="gray.500" fontWeight="semibold" mt={2} ml={2}>
                    {entry?.redeemed_date && dateUtils.timeAgo(new Date(entry.redeemed_date), savedLanguage)}
                  </Text>
                </HStack>
              </VStack>
            </HStack>
          </Box>
        //   <Box
        //     key={`${entry.reward._id}-${entry.redeemed_date}`}
        //     p={4}
        //     bg={bgColor}
        //     borderRadius="xl"
        //     borderBottomWidth="1px"
        //     borderColor="gray.200"
        //     w="full"
        //   >
        //   <HStack spacing={4} align="start" w="full">
        //     {/* Image Container */}
        //     <Box
        //       position="relative"
        //       w="80px"
        //       h="60px"
        //       flexShrink={0}
        //       borderRadius="lg"
        //       overflow="hidden"
        //       bg="gray.100"
        //     >
        //       {!imageLoaded && (
        //         <Flex
        //           position="absolute"
        //           top="0"
        //           left="0"
        //           w="full"
        //           h="full"
        //           align="center"
        //           justify="center"
        //           zIndex={1}
        //           bg="whiteAlpha.600"
        //         >
        //           <Spinner size="sm" color="teal.400" />
        //         </Flex>
        //       )}

        //       <Image
        //         src={entry.reward.image_url || '/default_reward.jpg'}
        //         alt={entry.reward.title}
        //         objectFit="cover"
        //         w="full"
        //         h="full"
        //         transition="opacity 0.3s ease"
        //         opacity={imageLoaded ? 1 : 0}
        //         onLoad={handleImageLoad}
        //       />
        //     </Box>

        //     {/* Reward Info */}
        //     <Box flex="1" minW="0" color={textbgColor}>
        //       <Text fontWeight="bold" fontSize="sm" noOfLines={2}>
        //         {entry.reward.title}
        //       </Text>
        //       <Text fontSize="xs" color="gray.500" mt={1}>
        //         {dateUtils.formatDate(entry.redeemed_date, savedLanguage)}
        //       </Text>
        //     </Box>

        //     {/* Points + Time Info */}
        //     <VStack align="flex-end" spacing={1} minW="90px">
        //       <HStack spacing={1}>
        //         <Text fontSize="lg" fontWeight="bold" color={badgeTextColor}>
        //           -{dateUtils.convertToBurmeseNumerals(entry.reward.points_required, savedLanguage)}
        //         </Text>
        //         <Badge colorScheme="red" px={2} py={0.5} borderRadius="md" fontSize="xs">
        //           {t('point')}
        //         </Badge>
        //       </HStack>
        //       <Text fontSize="xs" color="gray.400" fontWeight="medium">
        //         {entry.redeemed_date && dateUtils.timeAgo(new Date(entry.redeemed_date), savedLanguage)}
        //       </Text>
        //     </VStack>
        //   </HStack>
        // </Box>

        ))
      )}
    </VStack>

  );
};

export default RedeemedHistory;